.container {
    display: flex;
    flex-direction: row;
    gap: 48px;
    width: 100%;
    align-items: center;
}

@media (max-width: 1390px) {
    .icon {
        display: none;
    }
}

@media (max-width: 1024px) {
    .container {
        gap: 32px;
    }
    .actionText {
        display: none;
    }
    .icon {
        display: block;
    }
}
